import { useMe } from "components/use-hooks";
import { canAssignUserGroups } from "../helpers/user-access-helper";


const useCanAssignUserGroups = () => {

    const currentUser = useMe();

    return canAssignUserGroups(currentUser?.me);
};

export default useCanAssignUserGroups;
